export const LOGIN_USER = 'auth/LOGIN_USER';
export const VERIFY_TOKEN = 'auth/VERIFY_TOKEN';
export const RESET_PASSWORD = 'auth/RESET_PASSWORD';
export const FORGOT_PASSWORD = 'auth/FORGOT_PASSWORD';
export const SIGNUP = 'auth/SIGNUP';
export const VALIDATE_INVITATION_CODE = 'auth/VALIDATE_INVITATION_CODE';
export const IMPERSONATION_LOGIN = 'auth/IMPERSONATE';
export const VERIFY_TFA_CODE = 'auth/VERIFY_TFA_CODE';
export const GENERATE_TFA_CODE = 'auth/GENERATE_TFA_CODE';
export const VALIDATE_RETRY_TOKEN = 'auth/VALIDATE_RETRY_TOKEN';
export const GENERATE_LOGIN_OTP = 'auth/GENERATE_LOGIN_OTP';
export const VALIDATE_LOGIN_OTP = 'auth/VALIDATE_LOGIN_OTP';
export const GENERATE_LOGIN_LINK = 'auth/GENERATE_LOGIN_LINK';
export const VALIDATE_LOGIN_LINK = 'auth/VALIDATE_LOGIN_LINK';
